var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"display-2"},[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("\n    Nie znaleziono strony o podanym adresie."),_c('br'),_vm._v("\n    Aby przejść do strony głównej kliknij "),_c('router-link',{attrs:{"active-class":"activeNav","to":"/","exact":""}},[_vm._v("tutaj")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bf169ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = ciLx
// module chunks = 1